var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgBellOff = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9858 15.9787L6.42241 7.41537C6.24101 7.98773 6.14817 8.58663 6.14894 9.19149V13.8723C6.14894 14.6627 5.88778 15.392 5.44707 15.9787H14.9858V15.9787ZM16.39 17.383H2.6383C1.70213 17.383 1.70213 15.9787 2.6383 15.9787C3.80162 15.9787 4.74468 15.0357 4.74468 13.8723L4.74468 9.19237C4.74344 8.20469 4.94385 7.22902 5.33159 6.32455L1.20565 2.19861C0.931451 1.92441 0.931451 1.47985 1.20565 1.20565C1.47985 0.931451 1.92441 0.931451 2.19861 1.20565L6.66216 5.6692C6.67 5.67668 6.67764 5.68433 6.68509 5.69213L22.7944 21.8014C23.0686 22.0756 23.0686 22.5202 22.7944 22.7944C22.5202 23.0686 22.0756 23.0686 21.8014 22.7944L16.39 17.383ZM9.12462 4.09235C8.7869 4.28291 8.35864 4.16362 8.16808 3.8259C7.97752 3.48818 8.09681 3.05992 8.43453 2.86936C10.6815 1.60149 13.4326 1.62221 15.6602 2.92376C17.8878 4.22532 19.2566 6.6119 19.2553 9.19149V12.9362C19.2553 13.3239 18.941 13.6383 18.5532 13.6383C18.1654 13.6383 17.8511 13.3239 17.8511 12.9362V9.19113C17.8521 7.11053 16.7482 5.18586 14.9518 4.13622C13.1554 3.08658 10.9367 3.06988 9.12462 4.09235ZM14.2269 20.7778C13.7663 21.5718 12.9179 22.0605 12 22.0605C11.0821 22.0605 10.2337 21.5718 9.77309 20.7778C9.50156 20.3098 9.83929 19.7234 10.3804 19.7234H13.6196C14.1607 19.7234 14.4984 20.3098 14.2269 20.7778Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgBellOff;